import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const PESO = "₱";

export function formatPeso(n, opts = {}) {
  const { compact = false, decimals = 0 } = opts;
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  if (compact && Math.abs(n) >= 1000) {
    const units = [
      { v: 1e9, s: "B" },
      { v: 1e6, s: "M" },
      { v: 1e3, s: "K" },
    ];
    for (const u of units) {
      if (Math.abs(n) >= u.v) {
        return `${PESO}${(n / u.v).toFixed(n / u.v >= 100 ? 0 : 1)}${u.s}`;
      }
    }
  }
  return `${PESO}${Number(n).toLocaleString("en-PH", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
}

export function formatNumber(n, opts = {}) {
  const { compact = false, decimals = 0 } = opts;
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  if (compact && Math.abs(n) >= 1000) {
    const units = [
      { v: 1e9, s: "B" },
      { v: 1e6, s: "M" },
      { v: 1e3, s: "K" },
    ];
    for (const u of units) {
      if (Math.abs(n) >= u.v) return `${(n / u.v).toFixed(n / u.v >= 100 ? 0 : 1)}${u.s}`;
    }
  }
  return Number(n).toLocaleString("en-PH", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function pct(n, decimals = 1) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return `${(n * 100).toFixed(decimals)}%`;
}

export function signed(n, opts = {}) {
  if (n === null || n === undefined) return "—";
  const sign = n > 0 ? "+" : n < 0 ? "" : "";
  return sign + formatNumber(n, opts);
}
